// @flow

export const parsePlanLink = (link: string) => {
    const clientId = getToken('client', link);
    const batchId = getToken('batch', link);
    const planId = getToken('plan', link);

    return { clientId, batchId, planId };
};

export const parseBatchLink = (link: string) => {
    const clientId = getToken('client', link);
    const batchId = getToken('batch', link);
    return { clientId, batchId };
};

const getToken = (tokenName: string, url: string) => {
    if (!url) {
        return false;
    }

    let matchedToken = null;
    const tokens = url.split('/');
    tokens.forEach((token, i) => {
        if (i + 1 >= tokens.length) {
            return false;
        }

        if (token === tokenName) {
            matchedToken = tokens[i + 1];
        }
    });

    if (!matchedToken) {
        return false;
    }

    return matchedToken;
};
